const urlDashboard = 'dashboards';

export const getDashboards = () => ({
  method: 'GET',
  url: urlDashboard,
});

export default { getDashboards };
